export default __webpack_public_path__ + "static/zimny-zajac-7ed2466ff12c468cf559a85c779cf640.jpg";